import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import {
  Gender,
  MaritalStatus,
  UserSummaryType,
} from '../../../../api/types/user/user-summary.type';
import { UserType } from '../../../../api/types/user/user-type';
import { FileUploadFile } from 'primereact/fileupload';
import { updateAvatarOperations } from '../../search-users/compoenents/update-avatar-file-dialog/operations/update-avatar-operations';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import dateUtils from '../../../../utils/date-format';

const isEmpty = (str?: string) => !(str && str.trim() !== '');
const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
export const createUserOperation = async (
  image: FileUploadFile | undefined,
  firstName: string,
  lastName: string,
  nationalId: string,
  phoneNumber: string,
  additionalPhoneNumber: string | null,
  mail: string,
  dateOfBirth: Date | null,
  userType: UserType,
  city: string | null,
  street: string,
  houseNumber: string,
  flatNumber: string,
  postcode: string,

  gender: Gender | null,
  immigrateCountry: string | null,
  immigrateDate: Date | null,
  maritalStatus: MaritalStatus | null,

  branchIds: number[] | null,

  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
  onUserCreated?: (user: UserSummaryType) => void,
) => {
  try {
    if (
      isEmpty(firstName) ||
      isEmpty(lastName) ||
      isEmpty(nationalId) ||
      isEmpty(phoneNumber) ||
      isEmpty(mail) ||
      gender === null ||
      !dateOfBirth
    ) {
      toast.warn('יש להשלים את כל הפרטים');
      return;
    }

    // Validate branchIds for students
    if (
      userType === UserType.STUDENT &&
      (!branchIds || branchIds.length === 0)
    ) {
      toast.warn('יש לבחור לפחות שלוחה אחת לסטודנט');
      return;
    }

    // Check for the invalid condition (one null, one not null)
    if (
      (immigrateDate === null && immigrateCountry !== null) ||
      (immigrateDate !== null && immigrateCountry === null)
    ) {
      toast.warn('לא ניתן למלא פרטי הגירה חלקיים');
      return;
    }
    if (!isValidEmail(mail)) {
      toast.warn('יש להזין כתובת מייל תקינה');
      return;
    }

    if (nationalId.length !== 9) {
      toast.info('יש להזין מספר זהות תקינה בעל 9 ספרות');
      return;
    }

    if (
      userType === UserType.STUDENT &&
      (!branchIds || branchIds.length === 0)
    ) {
      toast.info('יש לצין לאיזה שלוחה לשייך את הסטודנט');
      return;
    }

    const formattedDateOfBirth = `${dateOfBirth.getFullYear()}-${(dateOfBirth.getMonth() + 1).toString().padStart(2, '0')}-${dateOfBirth.getDate().toString().padStart(2, '0')}`;

    const user = {
      firstName: firstName,
      lastName: lastName,
      nationalId: nationalId,
      phoneNumber: `+972${phoneNumber.replace(/-/g, '').substring(1)}`,
      additionalPhoneNumber: additionalPhoneNumber
        ? `+972${additionalPhoneNumber.replace(/-/g, '').substring(1)}`
        : null,

      city: city && city.trim() !== '' ? city : null,
      street: street && street.trim() !== '' ? street : null,
      houseNumber:
        houseNumber && houseNumber.trim() !== '' ? houseNumber : null,
      flatNumber: flatNumber && flatNumber.trim() !== '' ? flatNumber : null,
      postcode: postcode && postcode.trim() !== '' ? postcode : null,

      dateOfBirth: dateUtils.formattedDateWithNoTime(dateOfBirth),
      email: mail,

      gender: gender,
      immigrateCountry: immigrateCountry,
      immigrateDate: immigrateDate,
      maritalStatus: maritalStatus,

      role: userType,
    };
    setLoading(true);
    // TODO change
    const userRes = await appApi.createUser(user, 'Aa123456', branchIds);

    if (userRes.data.errCode) {
      toast.warn(displayErrorText(userRes.data.errCode));
      setLoading(false);
      return;
    }

    if (image) {
      await updateAvatarOperations(userRes.data.body.id, image, () => {
        //
      });
    }
    setLoading(false);
    onHide();

    // Notify parent component about the newly created user
    if (onUserCreated && userRes.data.body) {
      onUserCreated(userRes.data.body);
    }

    toast.success(`המשתמש ${firstName} ${lastName} נוצר בהצלחה`);
  } catch (e) {
    setLoading(false);
    console.error(`Couldn't create new user, with the error: ${e}`);
    toast.error(`יצירת המשתמש נכשלה, נסה שוב מאוחר יותר...`);
  }
};
